import { useEffect, useRef, type RefObject } from 'react'

/**
 * WhatsApp-artiges Scrollverhalten für einen Nachrichten-Container: neue Nachrichten
 * scrollen automatisch ans Ende, ABER nur wenn der Nutzer bereits am Ende war — wer
 * hochgescrollt hat, um ältere Nachrichten zu lesen, wird nicht nach unten gerissen.
 * Beim Channel-Wechsel wird immer ganz nach unten gesprungen (frischer Channel startet
 * am aktuellsten Stand).
 */
export function useAutoScrollToBottom(ref: RefObject<HTMLDivElement>, channelId: string | null, messages: unknown[]) {
  const stickToBottomRef = useRef(true)

  useEffect(() => {
    stickToBottomRef.current = true
  }, [channelId])

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const onScroll = () => {
      const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight
      stickToBottomRef.current = distanceFromBottom < 60
    }
    el.addEventListener('scroll', onScroll)
    return () => el.removeEventListener('scroll', onScroll)
  }, [ref])

  useEffect(() => {
    const el = ref.current
    if (!el || !stickToBottomRef.current) return
    el.scrollTop = el.scrollHeight
  }, [ref, messages])
}
